/**
 * Entry point for mybswhealth.
 */

// ---------------------------------------------------------
// polyfills for IE: order matters; keep them in this order.
//import "@babel/polyfill";
import "core-js/stable";
import "whatwg-fetch";
// ---------------------------------------------------------

import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import HistoryBinder from "./components/common/HistoryBinder";



ReactDOM.hydrate(
    <App isHome={true} isPharmacy={false} />
    , document.getElementById("ReactContainer"));
    

// only enable hmr if running on a local dev's machine...
//debugger;
//alert("IsLocalDev says: " + window.serverData.data.isLocalDev);
if (window.serverData.data.isLocalDev === true) {
    if (module && module.hot) {
        module.hot.accept();
    }
}